require('./angulartics');
module.exports = 'angulartics';



// WEBPACK FOOTER //
// ./~/angulartics/src/index.js